import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./NavBar.css";
import logo from "./images/spark-logo.png";

export default function NavBar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeItem, setActiveItem] = useState("");
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // تحديد العنصر النشط بناءً على المسار الحالي
  useEffect(() => {
    const path = location.pathname;
    setActiveItem(path);
  }, [location]);

  // التحكم في scroll الجسم عند فتح/إغلاق القائمة
  useEffect(() => {
    if (open) {
      document.body.classList.add("menu-open");
      // إعادة التعويم إلى الأعلى عند فتح القائمة
      window.scrollTo(0, 0);
    } else {
      document.body.classList.remove("menu-open");
    }
    
    // تنظيف عند unmount
    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [open]);

  // دالة للتحقق إذا كان العنصر نشطًا
  const isActive = (path) => {
    return activeItem === path;
  };

  // إغلاق القائمة عند تغيير المسار
  useEffect(() => {
    setOpen(false);
  }, [location]);

  return (
    <header
      className={`nav ${open ? "open" : ""} ${scrolled ? "scrolled" : ""}`}
    >
      <div className="nav-inner container">
        <Link to="/home">
          <img className="text-uppercase" src={logo} alt="logo" />
        </Link>

        <button
          className={`burger ${open ? "active" : ""}`}
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`menu ${open ? "show" : ""}`}>
          <Link
            to="/home"
            className={`item text-uppercase ${
              isActive("/home") ? "active" : ""
            }`}
            onClick={() => setOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/services"
            className={`item text-uppercase ${
              isActive("/services") ? "active" : ""
            }`}
            onClick={() => setOpen(false)}
          >
            Services
          </Link>
          <Link
            to="/billboards"
            className={`item text-uppercase ${
              isActive("/billboards") ? "active" : ""
            }`}
            onClick={() => setOpen(false)}
          >
            Billboards
          </Link>
          <Link
            to="/clintes"
            className={`item text-uppercase ${
              isActive("/clintes") ? "active" : ""
            }`}
            onClick={() => setOpen(false)}
          >
            Clients
          </Link>
          <Link
            to="/contact"
            className={`item text-uppercase ${
              isActive("/contact") ? "active" : ""
            }`}
            onClick={() => setOpen(false)}
          >
            GET IN TOUCH
          </Link>
        </nav>
      </div>
    </header>
  );
}